import { render } from "./CategoryTable.vue?vue&type=template&id=6d53362a&scoped=true"
import script from "./CategoryTable.vue?vue&type=script&lang=js"
export * from "./CategoryTable.vue?vue&type=script&lang=js"

import "./CategoryTable.vue?vue&type=style&index=0&id=6d53362a&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d53362a"]])

export default __exports__